export function StepHeader({ icon: Icon, title, subtitle }) {
  return (
    <div className="flex flex-col items-center text-center gap-3 mb-6" data-testid="kiosk-step-header">
      <div className="w-14 h-14 rounded-full bg-brand-cyan/10 text-brand-cyan flex items-center justify-center">
        <Icon size={26} />
      </div>
      <div>
        <h2 className="text-2xl sm:text-3xl font-black uppercase tracking-tight text-brand-navy">{title}</h2>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
    </div>
  );
}
